import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DataGridService {
  private _actionEmitter = new Subject<{ action; data }>();
  readonly actionEmitter$ = this._actionEmitter.asObservable();

  executeHeaderAction(actionName: string, data: any) {
    this._actionEmitter.next({ action: actionName, data });
  }
}
